import { REGEX_CONDITION } from '../../../constants';

/**
 * Function: isAdjustUrl
 * Description: Checks if the given URL matches the Adjust regex pattern.
 * Regex Used: REGEX_CONDITION.ADJUST_REGEX
 */
export function isAdjustUrl(url: string) {
  const adjustRegex = REGEX_CONDITION.ADJUST_REGEX;

  return adjustRegex.test(url);
}
